// ═══════════════════════════════════════════════════════════════════════════
// El PIN — la capa de datos
//
// Etapa 3 de `AUTENTICACION.md`. Protege lo que destruye un documento o mueve
// dinero, sin estorbar a quien solo levanta pedidos.
//
// ── DOS PASOS, Y NO ES CAPRICHO ────────────────────────────────────────────
//
// `comprobarPin` devuelve un VALE de dos minutos, y las acciones protegidas
// piden el vale y no el PIN. La razón está en la migración 0032 y vale
// repetirla: contar los intentos fallidos y lanzar la excepción en la misma
// transacción NO PUEDE funcionar, porque la excepción revierte el conteo. Con
// eso, el bloqueo tras cinco intentos nunca se disparaba — y un PIN de cuatro
// dígitos sin tope son diez mil combinaciones.
//
// El PIN nunca se guarda aquí. Se teclea, se cambia por un vale, y se olvida.
// ═══════════════════════════════════════════════════════════════════════════

import { supabase } from "./sesion.js";

async function rpc(nombre, args) {
  const { data, error } = await supabase.rpc(nombre, args);
  if (error) throw new Error(error.message);
  return data;
}

/** ¿Ya tiene PIN puesto? ¿Está bloqueado por intentos? */
export const estadoPin = () => rpc("estado_pin");

/** Poner el primero, o cambiarlo (entonces hace falta el anterior). */
export const ponerPin = (pin, anterior = null) =>
  rpc("poner_pin", { p_pin: pin, p_pin_anterior: anterior });

/**
 * Cambia el PIN por un vale.
 *
 * NO lanza cuando el PIN está mal: devuelve `{ ok:false, motivo }`. Es lo que
 * permite que el conteo de intentos sobreviva, así que quien llame tiene que
 * mirar el resultado.
 */
export const comprobarPin = (pin) => rpc("comprobar_pin", { p_pin: pin });

/** Lo que se le dice al usuario según por qué no pasó. */
export function motivoPin(r) {
  if (!r || r.ok) return "";
  if (r.motivo === "sin_pin") return "Todavía no has puesto un PIN. Se pone en Mi cuenta.";
  if (r.motivo === "bloqueado")
    return `Demasiados intentos. Espera ${r.minutos || 15} minutos.`;
  return r.quedan > 0
    ? `PIN incorrecto. Te quedan ${r.quedan} intento${r.quedan !== 1 ? "s" : ""}.`
    : "PIN incorrecto. Al siguiente fallo se bloquea un rato.";
}
